import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3af85f73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link active",
      id: "home-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#home-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "home-tab-pane",
      "aria-selected": "true"
    }, "Information générale")
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link",
      id: "profile-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#profile-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "profile-tab-pane",
      "aria-selected": "false"
    }, "Méta data")
  ])
], -1))
const _hoisted_4 = {
  class: "tab-content",
  id: "myTabContent "
}
const _hoisted_5 = {
  class: "tab-pane fade show active p-10",
  id: "home-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Titre "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Alias "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Sous titre "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_16 = { class: "col-md-12" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Contenu de l'article "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_19 = { class: "mb-0" }
const _hoisted_20 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_21 = { class: "product-upload" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Autres fichiers", -1))
const _hoisted_23 = { class: "dz-message needsclick" }
const _hoisted_24 = { class: "col-md-6 mt-3" }
const _hoisted_25 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Image principale ", -1))
const _hoisted_27 = { class: "col-md-6 mt-3" }
const _hoisted_28 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Icône de l'article ", -1))
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Catégorie "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Tags "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date de publication ", -1))
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Source de l'article ", -1))
const _hoisted_42 = { class: "col-md-6" }
const _hoisted_43 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Niveau ", -1))
const _hoisted_45 = {
  class: "tab-pane fade p-10",
  id: "profile-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Meta title ", -1))
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Meta Keyword ", -1))
const _hoisted_53 = { class: "col-md-12" }
const _hoisted_54 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Meta description ", -1))
const _hoisted_56 = { class: "mb-0" }
const _hoisted_57 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col-md-12" }
const _hoisted_60 = { class: "d-flex align-items-center" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
  type: "submit"
}, " Ajouter un article ", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1))
const _hoisted_64 = {
  class: "modal fade createNewModal",
  id: "PreviewOrActiveArticleModal",
  tabindex: "-1",
  ref: "addPreviewOrActiveArticleModalRef",
  "aria-hidden": "true"
}
const _hoisted_65 = { class: "modal-dialog modal-dialog-centered modal-md" }
const _hoisted_66 = { class: "modal-content p-15 p-md-40" }
const _hoisted_67 = { class: "modal-header ps-0 pe-0 pt-0 pb-15 pb-md-25" }
const _hoisted_68 = { class: "modal-title text-black" }
const _hoisted_69 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25 text-center" }
const _hoisted_70 = { class: "row" }
const _hoisted_71 = { class: "col-md-12" }
const _hoisted_72 = { class: "d-flex align-items-center justify-content-center mb-3" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close shadow-none",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_DropZone = _resolveComponent("DropZone")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Form, {
          ref: "articleForm",
          onSubmit: _ctx.addArticle,
          "validation-schema": _ctx.articleSchema
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createVNode(_component_Field, {
                        name: "titre",
                        type: "text",
                        modelValue: _ctx.title,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer le titre"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "titre",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_component_Field, {
                        name: "alias",
                        type: "text",
                        readonly: "true",
                        modelValue: _ctx.alias,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.alias) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer l'alias"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "alias",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createVNode(_component_Field, {
                        name: "sousTitre",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer le sous titre"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "sousTitre",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_QuillEditor, {
                          ref: "contenuEditor",
                          theme: "snow",
                          placeholder: "Écrivez le contenu",
                          toolbar: "full",
                          name: "contenu"
                        }, null, 512)
                      ]),
                      (_ctx.show === '1')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_20, "Ce champ est obligatoire"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_DropZone, {
                        name: "fichiers[]",
                        uploadOnDrop: true,
                        multipleUpload: true,
                        parallelUpload: 5,
                        maxFilesize: 10,
                        filesizeBase: 1024,
                        onAddedFile: _ctx.onFileAdd
                      }, null, 8, ["onAddedFile"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createVNode(_component_Field, {
                        name: "urlImage",
                        type: "file",
                        accept: "image/jpeg, image/png application/pdf",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Choisir une image"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "urlImage",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createVNode(_component_Field, {
                        name: "icone",
                        type: "file",
                        accept: "image/jpeg, image/png application/pdf",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Choisir une icône"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "icone",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createVNode(_component_Field, { name: "categorieArticle" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: _ctx.categorieArticlesOptions,
                            searchable: true,
                            "track-by": "label",
                            label: "label",
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, { placeholder: "Sélectionner la catégorie" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "categorieArticle",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createVNode(_component_Field, { name: "tags" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: _ctx.tagsOptions,
                            searchable: true,
                            multiple: "true",
                            mode: "tags",
                            "track-by": "label",
                            label: "label",
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, { placeholder: "Sélectionner le tag" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "tags",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createVNode(_component_Field, {
                        name: "datePublication",
                        type: "date",
                        value: _ctx.getCurrentDate(),
                        class: "form-control shadow-none fs-md-15 text-black"
                      }, null, 8, ["value"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "datePublication",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createVNode(_component_Field, {
                        name: "source",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "source",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createVNode(_component_Field, {
                        name: "niveau",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "niveau",
                        class: "text-danger"
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _hoisted_49,
                      _createVNode(_component_Field, {
                        name: "metaTitle",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer le meta title"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "metaTitle",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _createVNode(_component_Field, {
                        name: "metaKeyword",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer le meta keyword"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "metaKeyword",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _createElementVNode("div", _hoisted_56, [
                        _createVNode(_component_QuillEditor, {
                          ref: "metaDescriptionEditor",
                          theme: "snow",
                          placeholder: "Ecrire la meta description",
                          toolbar: "full",
                          name: "metaDescription"
                        }, null, 512)
                      ]),
                      (_ctx.show === '1')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_57, "Ce champ est obligatoire"))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _hoisted_61,
                  _createVNode(_component_router_link, {
                    to: "/liste-articles",
                    class: "btn btn-danger transition border-0 lh-1 fw-medium"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_62,
                      _hoisted_63,
                      _createTextVNode("Annuler")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ]),
    _createElementVNode("div", _hoisted_64, [
      _createElementVNode("div", _hoisted_65, [
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("h5", _hoisted_68, " L'article: " + _toDisplayString(_ctx.createdArticle?.titre) + " a bien été créé ", 1)
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("button", {
                    class: "default-btn me-3 transition border-0 fw-medium text-white pt-2 pb-2 ps-3 pe-3 rounded-1 fs-md-15 fs-lg-16 bg-success",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.previewArticle(_ctx.createdArticle?.alias, _ctx.createdArticle?.alias)))
                  }, " Prévisualiser l'article "),
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchArticle(_ctx.createdArticle?.alias, _ctx.createdArticle?.alias))),
                    class: "default-btn me-3 transition border-0 fw-medium text-white pt-2 pb-2 ps-3 pe-3 rounded-1 fs-md-15 fs-lg-16 bg-danger"
                  }, " Activer l'article ")
                ])
              ])
            ])
          ]),
          _hoisted_73
        ])
      ])
    ], 512)
  ], 64))
}